export function resolveLogo(logo?: string, opts?: { forceJpeg?: boolean, toLower?: boolean }): string {
    if (!logo) return '';
    let name = logo;
    if (opts?.toLower) name = name.toLowerCase();
    if (opts?.forceJpeg && !name.endsWith('.jpeg')) name = name + '.jpeg';
    if (name.startsWith('data:image/') || name.startsWith('https')) {
        return name;
    }
    return `https://assets.clearitty.com/${encodeURIComponent(name)}`;
}

// Helper to generate all logo variations
export function getLogoVariations(logo?: string): string[] {
    if (!logo) return [];
    const base = logo;
    const lower = logo.toLowerCase();
    return [
        resolveLogo(base),
        resolveLogo(lower, { toLower: true }),
        resolveLogo(base, { forceJpeg: true }),
        resolveLogo(lower, { toLower: true, forceJpeg: true })
    ];
}